import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { catchError, tap } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

import { NotificationService, SessionService, MessageService } from '../../shared/services';
import { ModalService } from '../../shared/modules/modal/modal.service';
import { CentralMessage } from 'src/app/shared/models';
import { TranslationConstants } from 'src/app/shared/constants';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

  constructor(
    private _notificationsService: NotificationService,
    private _router: Router,
    private _modalService: ModalService,
    private _sessionService: SessionService,
    private _messageService: MessageService,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const responsePayload = event.body;

          if (responsePayload && responsePayload.message) {
            const message: CentralMessage = responsePayload.message;
            this._messageService.displayMessage({
              type: 'message',
              body: message.body,
            });
          }
        }
      }),
      catchError((error) => {
        if (error.status === 401) {
          this._modalService.closeModal();
          this._router.navigate([`/login`]);
          this._sessionService.emptySession();
        }
        if (error.status === 403 && error.error.type === 'TYPE_EULA_NOT_ACCEPTED') {
          this._modalService.closeModal();
          this._router.navigate(['/eula']);
        }
        if (error.status === 500) {
          if (error.error && error.error.errors && error.error.errors.MismatchPrincipleHeaders) {
            this._messageService.displayMessage({
              type: 'error',
              body: `${error.error.errors.MismatchPrincipleHeaders} It seems like container has been changed in another tab, please refresh your browser to update current container.`
            });

            this._notificationsService.notify(error);

            return throwError(error);
          }
        }
        if (error instanceof HttpErrorResponse) {
          let message = this.getNested(error, 'error', 'message', 'body');
          message = message || this.getNested(error, 'error', 'errors', 'message');
          message = message || this.getNested(error, 'error', 'errors', 'global');
          message = message || TranslationConstants.GLOBAL_SERVER_ERROR;

          if (message) {
            this._messageService.displayMessage({
              type: 'error',
              body: message
            });
          }
        }
        this._notificationsService.notify(error);

        return throwError(error);
      }) as any);
  }

  getNested(error: HttpErrorResponse, level: string, ...rest: string[]) {
    if (error === undefined) {
      return null;
    }
    if (rest.length === 0 && error.hasOwnProperty(level)) {
      return error[level];
    }
    return this.getNested(error[level], rest[0], ...rest.slice(1));
  }
}
